import { Color } from '@material-ui/lab';
import React, { useContext } from 'react';
import { RectangularChip } from 'framework/components/chips/RectangularChip';
import { IInventoryItem, InventoryStatus } from 'gen/ApiClient';
import { RecordContext } from 'shared/records/RecordContext';

const colorRecord: Record<InventoryStatus, Color> = {
	InRepair: 'error',
	InStock: 'success',
	InTestOrLoan: 'warning',
	NotInventoried: 'info',
	Ordered: 'info',
	ReturnedToSupplier: 'info',
	Sold: 'success',
	Broken: 'error',
};

const fillRecord: Record<InventoryStatus, boolean> = {
	InRepair: true,
	InStock: false,
	InTestOrLoan: false,
	NotInventoried: false,
	Ordered: false,
	ReturnedToSupplier: true,
	Sold: true,
	Broken: false,
};

interface IProps {
	item: IInventoryItem;
	style?: React.CSSProperties;
}

export const InventoryStatusChip = ({ item, style }: IProps) => {
	const { inventoryStatusRecord } = useContext(RecordContext);

	return (
		<RectangularChip
			style={style}
			label={inventoryStatusRecord[item.status as InventoryStatus]}
			fill={fillRecord[item.status as InventoryStatus]}
			color={colorRecord[item.status as InventoryStatus]}
		/>
	);
};
